import axios from "axios";

export const callExternalApi = async (options) => {
  try {
    const response = await axios(options.config);

    const { data } = response;

    return {
      data,
      error: null,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error;

      const { response } = axiosError;

      let message = "http request failed";
      let statusCode = 500;

      if (response && response.statusText) {
        message = response.statusText;
      }

      if (axiosError.message) {
        message = axiosError.message;
      }

      if (response && response.data && response.data.message) {
        message = response.data.message;
      }

      if (response && response.status) {
        statusCode = response.status;
      }

      return {
        data: null,
        error: {
          message,
          statusCode,
        },
      };
    }

    return {
      data: null,
      error: {
        message: error.message,
      },
    };
  }
};
